import { useClerk } from '@clerk/react-router';
import { useState, type ReactElement, type ReactNode } from 'react';
import { cacheExchange, createClient, fetchExchange, Provider } from 'urql';

export type UrqlProviderProps = {
    children: ReactNode;
};

export function UrqlProvider({ children }: UrqlProviderProps): ReactElement {
    const clerk = useClerk();

    const [client] = useState(() =>
        createClient({
            url: '/api/graphql',
            exchanges: [cacheExchange, fetchExchange],
            fetch: async (input, init) => {
                const token = await clerk.session?.getToken();
                if (!clerk.session || !token) {
                    window.location.href = '/sign-in';
                    throw new Error('No active session');
                }
                const headers = new Headers(init?.headers);
                headers.set('Authorization', `Bearer ${token}`);
                headers.set('x-clerk-user-id', clerk.session.user.id);
                return fetch(input, { ...init, headers });
            },
        }),
    );

    return <Provider value={client}>{children}</Provider>;
}
